import { render } from "./SupplierListModal.vue?vue&type=template&id=98306368&scoped=true"
import script from "./SupplierListModal.vue?vue&type=script&lang=js"
export * from "./SupplierListModal.vue?vue&type=script&lang=js"

import "./SupplierListModal.vue?vue&type=style&index=0&id=98306368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98306368"]])

export default __exports__